import React, { useState, useEffect, useCallback } from "react";
import { FONT_ROBOTO_MONO } from "../../../utils/fonts";
import { Spinner } from "reactstrap";
import Select from "react-select";
import { stylesSelect, DropdownIndicator, ClearIndicator } from "../../../Store/styled/select";
import moment from "moment";
import { formatUiDateTime, UI_DATEPICKER_FORMAT } from "utils/dateFormats";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import _ from "lodash";
import {
  getSegmentOptionList,
  getAccountCommonList,
  setFocusState,
} from "../../../Store/Reducer/common.slice";
import DatePicker from "react-datepicker";
import {
  getOTDReportLogList,
  setFilterDataUpdateLog,
  setIsFilterDataUpdateLog,
  setOTDReportLogCurrentPage,
  setOTDReportLogCurrentSearchText,
} from "../../../Store/Reducer/report.slice";
import { getSessionData } from "utils/common";
import useMobileViewport from "hooks/useMobileViewport";
import MobileRecordCard from "components/mobile/MobileRecordCard";
import MobileRecordList from "components/mobile/MobileRecordList";

// ─── Table ───────────────────────────────────────────────────────────────────

function TableUpdateLog({ loading }) {
  const dispatch = useDispatch();
  const isMobileViewport = useMobileViewport();
  const [data, setData] = useState([]);
  const {
    OTDReportLogCurrentSearchText,
    OTDReportLogLimit,
    startApiCallOTDReportLogList,
    OTDReportLogTotal,
    OTDReportLogList,
    OTDReportLogCurrentPage,
    filterDataUpdateLog,
  } = useSelector(({ report }) => report);

  useEffect(() => {
    if (startApiCallOTDReportLogList) {
      dispatch(getOTDReportLogList({
        data: filterDataUpdateLog, pageNo: 1, pageSize: 20,
        searchText: OTDReportLogCurrentSearchText,
      }));
    }
  }, [startApiCallOTDReportLogList]);

  useEffect(() => {
    setData(OTDReportLogList?.length > 0 ? OTDReportLogList : []);
  }, [OTDReportLogList]);

  const loadMore = () => {
    if (data.length < OTDReportLogTotal) {
      const next = OTDReportLogCurrentPage + 1;
      dispatch(setOTDReportLogCurrentPage(next));
      dispatch(getOTDReportLogList({
        data: filterDataUpdateLog, pageNo: next, pageSize: 20,
        searchText: OTDReportLogCurrentSearchText, appendData: true,
      }));
    }
  };

  const renderDevice = (row) => {
    if (row.deviceName === "WEB" || row.deviceType === 1)
      return <i className="material-icons-outlined" style={{ fontSize: 16 }}>public</i>;
    if (row.deviceName === "IOS")
      return <i className="fa-brands fa-apple" />;
    return <i className="material-icons-outlined" style={{ fontSize: 16 }}>phone_iphone</i>;
  };

  if (isMobileViewport) {
    return (
      <div className="rpt-table-panel rpt-table-panel--mobile-cards fx-module--mobile-cards">
        <MobileRecordList
          loading={loading && data.length === 0}
          loadingText="Loading ..."
          empty={!loading && data.length === 0}
          emptyText="No data found"
        >
          {data.map((row, idx) => {
            const isBuy = row.orderTypeName === "Buy";
            return (
              <MobileRecordCard
                key={idx}
                title={row.script}
                subtitle={[row.userName, row.tradeTypeName, row.actionType].filter(Boolean).join(" · ")}
                badge={row.orderTypeName}
                badgeVariant={isBuy ? "buy" : "sell"}
                variant={isBuy ? "buy" : "sell"}
                actions={renderDevice(row)}
                fields={[
                  { label: "Group No", value: row.groupNo },
                  { label: "Lot", value: row.lot },
                  { label: "Qty", value: row.qty },
                  { label: "Rate", value: row.rate },
                  {
                    label: "Add Time",
                    value: row.addDate ? formatUiDateTime(row.addDate, "-") : "-",
                  },
                  { label: "Act User", value: row.createdByname },
                  { label: "IP Address", value: row.userIp, fullWidth: true },
                  {
                    label: "Act Time",
                    value: row.actDate ? formatUiDateTime(row.actDate, "-") : "-",
                    fullWidth: true,
                  },
                ]}
              />
            );
          })}
        </MobileRecordList>
        {!loading && data.length > 0 && data.length < OTDReportLogTotal && (
          <div className="rpt-load-more">
            <button className="rpt-btn" onClick={loadMore}>
              Load More &nbsp;<span style={{ color: "var(--blue)" }}>({data.length} / {OTDReportLogTotal})</span>
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="rpt-table-panel">
      <div className="rpt-table-scroll">
        <table className="rpt-table">
          <thead>
            <tr>
              <th className="text-center" style={{ width: 36 }}></th>
              <th>O/T</th>
              <th>Action</th>
              <th>Group No</th>
              <th>Client</th>
              <th>Script</th>
              <th>Type</th>
              <th className="text-right">Lot</th>
              <th className="text-right">Qty</th>
              <th className="text-right">Rate</th>
              <th>Add Time</th>
              <th>Act User</th>
              <th>IP Address</th>
              <th>Act Time</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx} className={row.orderTypeName === "Buy" ? "row-buy" : "row-sell"}>
                <td className="text-center col-muted">{renderDevice(row)}</td>
                <td className="col-muted">{row.tradeTypeName}</td>
                <td>{row.actionType}</td>
                <td className="col-muted">{row.groupNo}</td>
                <td>{row.userName}</td>
                <td style={{ fontWeight: 600 }}>{row.script}</td>
                <td className={row.orderTypeName === "Buy" ? "col-green" : "col-red"}>{row.orderTypeName}</td>
                <td className="text-right">{row.lot}</td>
                <td className="text-right">{row.qty}</td>
                <td className="text-right">{row.rate}</td>
                <td className="col-muted">
                  {row.addDate ? formatUiDateTime(row.addDate, "-") : "-"}
                </td>
                <td className="col-muted">{row.createdByname}</td>
                <td className="col-muted" style={{ fontFamily: FONT_ROBOTO_MONO, fontSize: 11 }}>{row.userIp}</td>
                <td className="col-muted">
                  {row.actDate ? formatUiDateTime(row.actDate, "-") : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {loading && <div className="rpt-loading">Loading ...</div>}
        {!loading && data.length === 0 && <div className="rpt-empty">No data found</div>}
      </div>
      {!loading && data.length > 0 && data.length < OTDReportLogTotal && (
        <div className="rpt-load-more">
          <button className="rpt-btn" onClick={loadMore}>
            Load More &nbsp;<span style={{ color: "var(--blue)" }}>({data.length} / {OTDReportLogTotal})</span>
          </button>
        </div>
      )}
    </div>
  );
}

// ─── Main Page ───────────────────────────────────────────────────────────────

function ReportUpdateLog() {
  const dispatch = useDispatch();
  const { userRole } = useSelector(({ auth }) => auth);
  const {
    OTDReportLogLoading,
    OTDReportLogCurrentSearchText,
    OTDReportLogLimit,
    OTDReportLogTotal,
    filterDataUpdateLog,
    isFilterDataUpdateLog,
  } = useSelector(({ report }) => report);
  const { segmentsList, accountOptionList } = useSelector(({ common }) => common);
  const [searchText, setSearchText] = useState("");

  const localData = getSessionData();
  const userName  = localData?.userName || "";

  const initialSaveState = { tradeType: "1", segmentId: "", userId: "", startDate: new Date(), endDate: new Date() };
  const [initialForm, setInitialForm] = useState(initialSaveState);

  useEffect(() => {
    if (isFilterDataUpdateLog) setInitialForm(filterDataUpdateLog);
    else {
      dispatch(getSegmentOptionList());
      dispatch(getAccountCommonList({ roleName: "User" }));
      setInitialForm({ ...initialSaveState, tradeType: "1" });
    }
    return () => { dispatch(setFocusState(false)); };
  }, []);

  const debounceSearch = useCallback(
    _.debounce((value, filterData) => {
      dispatch(setOTDReportLogCurrentPage(1));
      dispatch(setOTDReportLogCurrentSearchText(value));
      dispatch(getOTDReportLogList({ data: filterData, pageNo: 1, pageSize: 20, searchText: value }));
    }, 800), []
  );

  return (
    <div className="rpt-page">
      {OTDReportLogLoading && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,.3)", zIndex: 999 }}>
          <Spinner color="primary" />
        </div>
      )}

      <div className="rpt-title-bar">
        <div className="rpt-title">Order / Trade Edit / Delete Log</div>
      </div>
      <hr className="rpt-divider" />

      <Formik
        enableReinitialize
        initialValues={initialForm}
        onSubmit={(data) => {
          dispatch(setIsFilterDataUpdateLog(true));
          dispatch(setFilterDataUpdateLog(data));
          dispatch(getOTDReportLogList({ data, pageNo: 1, pageSize: 20, searchText: OTDReportLogCurrentSearchText }));
        }}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <div className="rpt-filter">
              <div className="rpt-filter-row">
                {/* Log type */}
                <div>
                  <div className="rpt-filter-label">Log Type</div>
                  <div className="rpt-radio-group">
                    {[{ val: "1", label: "Trade Log" }, { val: "2", label: "Order Log" }].map(({ val, label }) => (
                      <label key={val} className={`rpt-radio ${values.tradeType === val ? "active" : ""}`}>
                        <input type="radio" name="tradeType" value={val} checked={values.tradeType === val}
                          onChange={(e) => handleChange("tradeType")(e.target.value)} />
                        {label}
                      </label>
                    ))}
                  </div>
                </div>

                {/* Segment */}
                <div style={{ minWidth: 150 }}>
                  <div className="rpt-filter-label">Segment</div>
                  <Select options={segmentsList} styles={stylesSelect} isClearable
                    components={{ DropdownIndicator, ClearIndicator }} placeholder="Segment" value={values.segmentId}
                    onChange={(opt) => handleChange({ target: { name: "segmentId", value: opt } })}
                  />
                </div>

                {/* Client */}
                <div style={{ minWidth: 170 }}>
                  <div className="rpt-filter-label">Client</div>
                  {userRole === "User"
                    ? <input className="form-control" value={userName} disabled style={{ background: "var(--bg-secondary)", border: "1px solid var(--border)", color: "var(--text-muted)", borderRadius: 4, padding: "6px 10px", fontSize: 12 }} />
                    : <Select options={accountOptionList} styles={stylesSelect} isClearable
                        components={{ DropdownIndicator, ClearIndicator }} placeholder="Client" value={values.userId}
                        onChange={(opt) => handleChange({ target: { name: "userId", value: opt } })}
                      />
                  }
                </div>

                {/* Dates */}
                <div>
                  <div className="rpt-filter-label">From</div>
                  <DatePicker className="form-control" dateFormat={UI_DATEPICKER_FORMAT} selected={values.startDate}
                    onChange={(d) => setFieldValue("startDate", d)} />
                </div>
                <div>
                  <div className="rpt-filter-label">To</div>
                  <DatePicker className="form-control" dateFormat={UI_DATEPICKER_FORMAT} selected={values.endDate}
                    onChange={(d) => setFieldValue("endDate", d)} />
                </div>

                <div style={{ alignSelf: "flex-end" }}>
                  <button type="submit" className="rpt-btn rpt-btn--primary">
                    <i className="material-icons-outlined">search</i> Find Log
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      {/* Search + total */}
      <div className="rpt-search-bar">
        <div className="rpt-search-input">
          <span className="rpt-search-icon"><i className="material-icons-outlined">search</i></span>
          <input placeholder="Search..." value={searchText}
            onChange={(e) => { setSearchText(e.target.value); debounceSearch(e.target.value, filterDataUpdateLog); }} />
        </div>
        <div className="rpt-stats">
          Total Records: <strong>{OTDReportLogTotal}</strong>
        </div>
      </div>

      <TableUpdateLog loading={OTDReportLogLoading} />
    </div>
  );
}

export default ReportUpdateLog;
